import CheckIcon from "components/Icons/CheckIcon";
import { useAlertContext } from "./AlertContext";
import { ISos } from "models/sos";
import { Link } from "react-router-dom";
import { RouteName } from "constants/route";
import ViewIcon from "components/Icons/ViewIcon";
import { isDispatcher } from "helpers/privilege";

interface IProps {
  sos: ISos;
}

export default function Action({ sos }: IProps) {
  const { showDeactivate } = useAlertContext();

  // Validate SOS ID before creating link
  // Check if ID exists and is a valid UUID format (not "undefined", "null", or empty)
  if (!sos?.id || sos.id === "undefined" || sos.id === "null" || sos.id.trim() === "") {
    console.error("SOS ID is invalid or missing:", { sos, id: sos?.id });
    return (
      <div className="flex items-center gap-x-3 pl-4">
        <span className="text-red-500 text-xs">Invalid ID</span>
      </div>
    );
  }

  const detailUrl = RouteName.SOS_DETAIL.replace(":id", sos.id);

  return (
    <div className="flex items-center gap-x-3 pl-4">
      <Link
        to={detailUrl}
        className="rounded-full hover:text-black"
      >
        <ViewIcon />
      </Link>
      {isDispatcher() && (
        <button
          onClick={() => showDeactivate(sos)}
          className="rounded-ful hover:text-green-900 text-green-600"
        >
          <CheckIcon />
        </button>
      )}
    </div>
  );
}
